// src/services/jobBoardApi.js
import api from './api';

const jobBoardApi = {
  // Get recommended jobs based on a resume
  // If versionId is 'latest', the backend will use the latest version
  getRecommendedJobs: (resumeId, versionId = 'latest', limit = 10, refresh = false) => 
    api.get('/api/job-board/recommended', { 
      params: { resumeId, versionId, limit, refresh } 
    }),
  
  // Search for jobs
  searchJobs: (query, location = null, employment_type = null, sponsor = null, limit = 20) => 
    api.get('/api/job-board/search', { 
      params: { query, location, employment_type, sponsor, limit } 
    }),
  
  // Get job details
  getJobDetails: (jobId) => 
    api.get(`/api/job-board/job/${jobId}`),
  
  // Save a job to user's profile
  saveJob: (jobId) => 
    api.post('/api/job-board/save-job', { job_id: jobId }),
  
  // Remove a saved job from user's profile
  unsaveJob: (jobId) => 
    api.delete('/api/job-board/unsave-job', { data: { job_id: jobId } }),
  
  // Apply flow handled via saved jobs
};

export default jobBoardApi;